import { NAP } from "@/lib/nap";

const ORG_ID = `${NAP.siteUrl}/#organization`;
const BLOG_PAGE_ID = `${NAP.siteUrl}/blog#blogpage`;
const LOGO_URL = `${NAP.siteUrl}/img/logo.svg`;
const OG_IMAGE = `${NAP.siteUrl}/img/og/siddhivinayak-group-og.jpg`;

const organization = {
  "@type": ["Organization", "RealEstateAgent"],
  "@id": ORG_ID,
  name: NAP.brand,
  alternateName: NAP.legalName,
  url: NAP.siteUrl,
  logo: LOGO_URL,
  telephone: NAP.phone,
  email: NAP.email,
  address: {
    "@type": "PostalAddress",
    streetAddress: NAP.streetAddress,
    addressLocality: NAP.addressLocality,
    addressRegion: NAP.addressRegion,
    postalCode: NAP.postalCode,
    addressCountry: NAP.addressCountry,
  },
};

const blogPage = {
  "@type": "Blog",
  "@id": BLOG_PAGE_ID,
  url: `${NAP.siteUrl}/blog`,
  name: "Real Estate Blog | Siddhivinayak Group",
  description:
    "Insights, guides, and market analysis for property buyers, sellers, and investors across India.",
  inLanguage: "en-IN",
  isPartOf: { "@id": `${NAP.siteUrl}/#website` },
  publisher: { "@id": ORG_ID },
  primaryImageOfPage: { "@type": "ImageObject", url: OG_IMAGE },
};

const breadcrumb = {
  "@type": "BreadcrumbList",
  itemListElement: [
    { "@type": "ListItem", position: 1, name: "Home", item: NAP.siteUrl },
    {
      "@type": "ListItem",
      position: 2,
      name: "Blog",
      item: `${NAP.siteUrl}/blog`,
    },
  ],
};

export const BLOG_LIST_SCHEMA = {
  "@context": "https://schema.org",
  "@graph": [organization, blogPage, breadcrumb],
};